import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import BetSelector from "./components/BetSelector";
import ChatComponent from "./components/chat";
import { getRaceById } from "./services/GridServices";
import routes from "./routes";
import "./styles.css";

export default function App() {
  const [showBetSelector, setShowBetSelector] = useState(false);
  const [selectedRaceData, setSelectedRaceData] = useState(null);

  const handleShowBetSelector = async (raceId) => {
    try {
      const raceData = await getRaceById(raceId);
      setSelectedRaceData(raceData);
      setShowBetSelector(true);
    } catch (error) {
      console.error("Error fetching race data:", error);
    }
  };

  const handleCloseBetSelector = () => {
    setShowBetSelector(false);
    setSelectedRaceData(null);
  };

  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <Routes>
          {routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={React.cloneElement(route.element, {
                onPlaceBet: handleShowBetSelector,
              })}
            />
          ))}
        </Routes>
        {showBetSelector && selectedRaceData && (
          <BetSelector
            onClose={handleCloseBetSelector}
            raceData={selectedRaceData}
          />
        )}
        <ChatComponent />
      </div>
    </Router>
  );
}
